
import { mapState, mapGetters } from "vuex";

export default {
  data() {
    return {
      deliveryData: [
        { label: "Channel", data: "channel" },
        { label: "Order ID", data: "source_id" },
        { label: "Brand", data: "restaurant_id" },
        { label: "Customer Name", data: "customer_name" },
        { label: "Customer Number", data: "customer_mobile" },
        { label: "Delivering to", data: "delivery_address" },
        { label: "Instructions", data: "instructions" },
        { label: "Payment", data: "mode" }
      ]
    };
  },
  computed: {
    ...mapState("reciever", ["orderDetails"]),
    ...mapGetters("restaurant", ["getRestaurantName", "hasMultipleBrands"])
  },
  methods: {
    shouldShowRow(row) {
      switch (row.data) {
        case "restaurant_id":
          return this.hasMultipleBrands;
        case "delivery_address":
          return (
            this.orderDetails.order_type !==
            this.$constants.OrderTypes.TAKE_AWAY.id
          );
        default:
          return true;
      }
    }
  }
};
